webpackJsonp([70144966829960],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(18);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _ElevationsLogo = __webpack_require__(206);
	
	var _ElevationsLogo2 = _interopRequireDefault(_ElevationsLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'container content', id: 'content' },
	      _react2.default.createElement(
	        'section',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'has-text-centered', style: { marginBottom: '50px' } },
	          'Contact Us for a Quote!'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement('iframe', { name: 'votar', style: { display: 'none' } }),
	            _react2.default.createElement(
	              'form',
	              { method: 'post', target: 'votar', id: 'contact', 'netlify-honeypot': 'url', 'data-netlify': 'true' },
	              _react2.default.createElement(
	                'p',
	                { id: 'formResponse', style: { color: 'green', opacity: '0', transition: 'opacity .25s', textAlign: 'center' } },
	                'Thanks for reaching out to us. We\'ll be in contact as soon as possible!'
	              ),
	              _react2.default.createElement('input', { type: 'text', name: 'name', placeholder: 'Name', style: { width: '100%', padding: '5px', fontSize: '14px', marginBottom: '10px' } }),
	              _react2.default.createElement('input', { type: 'text', name: 'email', placeholder: 'Email', style: { width: '100%', padding: '5px', fontSize: '14px', marginBottom: '10px' } }),
	              _react2.default.createElement('input', { type: 'text', name: 'subject', placeholder: 'Subject', style: { width: '100%', padding: '5px', fontSize: '14px', marginBottom: '10px' } }),
	              _react2.default.createElement(
	                'p',
	                { style: { display: 'none' } },
	                'Empty: ',
	                _react2.default.createElement('input', { type: 'text', name: 'url' })
	              ),
	              _react2.default.createElement('textarea', { name: 'message', placeholder: 'Message', style: { width: '100%', padding: '5px', fontSize: '14px', marginBottom: '10px' } }),
	              _react2.default.createElement('input', { type: 'submit', name: 'submit', value: 'Send', onClick: formSumbit, className: 'button' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement('img', { src: _ElevationsLogo2.default, alt: 'Elevations Casework', style: { margin: '0 auto', display: 'block' } }),
	            _react2.default.createElement(
	              'p',
	              { style: { margin: '0' }, className: 'has-text-centered' },
	              '7640 Louis Rich Court'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { margin: '0' }, className: 'has-text-centered' },
	              'Davenport, IA 52804'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { margin: '0' }, className: 'has-text-centered' },
	              'Phone: 563-381-9062'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              { style: { margin: '0' }, className: 'has-text-centered' },
	              'Hours of Operation: 7:00am \u2013 3:30pm'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var formSumbit = function formSumbit() {
	  setTimeout(function () {
	    document.getElementById('contact').reset();
	    document.getElementById('formResponse').style.opacity = '1';
	  }, 1000);
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-7ee70489c8f5b80f5e5c.js